import { TableCell, TableRow } from "@material-ui/core";
import { TableAction, TableWrapper } from "App/Component/ui";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { useDatatables } from "App/hooks";
import {
  defaultDateDisplay,
  formatNumber,
  tipeKartuName,
  tipePembayaranName,
} from "App/utils/helpers";
import React from "react";
import { headCells } from "./helpers";
export default function TableListPembayaran({ rows, clickDelete }) {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "jumlah_bayar",
    orderByRow: ["jumlah_bayar"],
  });

  return (
    <>
      <TableWrapper
        title='Daftar Pembayaran by Pembelian'
        setQ={setQ}
        withAddButton={false}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        withSearch={false}
        // type='CUSTOM'
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}>
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableItemListPembayaran
                row={row}
                clickDelete={clickDelete}
                index={index}
              />
            );
          })}
      </TableWrapper>
    </>
  );
}

export const TableItemListPembayaran = ({
  row,
  clickDelete,
  index,
  withUpdate = false,
  clickUpdate,
}) => {
  return (
    <TableRow
      hover
      tabIndex={-1}
      key={index}
      style={{
        backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
      }}>
      <TableCell component='th' scope='row' padding='none' align='center'>
        {index + 1}
      </TableCell>

      <TableCell component='th' scope='row' padding='none'>
        <TableAction
          clickDelete={() => clickDelete(row.id)}
          isUpdate={withUpdate}
          clickUpdate={() => clickUpdate(row)}
        />
      </TableCell>
      <TableCell align='left'>{row.id}</TableCell>
      <TableCell align='left'>{row.idgl}</TableCell>
      <TableCell align='left'>{row.pembelian_id}</TableCell>
      <TableCell align='left'>{row.nama_supplier}</TableCell>

      <TableCell align='left'>
        {defaultDateDisplay(row.tanggal_masuk, true)}
      </TableCell>
      <TableCell align='right'>{formatNumber(row.jumlah_bayar)}</TableCell>
      <TableCell align='left'>{row?.kas_name}</TableCell>
      <TableCell align='left'>
        {tipePembayaranName(row.tipe_pembayaran_id)}
      </TableCell>
      <TableCell align='left'>{tipeKartuName(row.tipe_kartu)}</TableCell>
      <TableCell align='left'>{row.no_kartu}</TableCell>
      <TableCell align='left'>{row.no_transfer}</TableCell>
    </TableRow>
  );
};
